<template>
  <div class="container">
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>返回</span>
    </div>
    <a-form :form="form">
      <div class="header">
        <span class="title">{{ !id ? '新建课程' : '编辑课程' }}</span>
      </div>
      <div class="list">
        <a-form-item :label="'课程名称'" :colon="false">
          <a-input
            maxLength="15"
            v-decorator="['name', { rules: [{ required: true, message: '请输入课程名称' }] }]"
            placeholder="请输入课程名称"
          />
        </a-form-item>
        <a-form-item :label="'请选择班级'" :colon="false">
          <a-select
            v-decorator="['classId', { rules: [{ required: true, message: '请选择班级' }] }]"
            placeholder="请选择班级"
          >
            <a-select-option v-for="item in classOptions" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item :label="'开始时间'" :colon="false">
          <a-date-picker
            hideDisabledOptions
            @change="checkStartDate"
            format="YYYY-MM-DD HH:mm"
            placeholder="请选择开课时间"
            :disabled-date="disabledStartDate"
            :disabledTime="disabledStartTime"
            :show-time="{ defaultValue: defaultStartDate }"
            v-decorator="['startTime', { rules: [{ required: true, message: '请选择开课时间' }] }]"
          >
            <img src="@/assets/icons/icon_rq.png" slot="suffixIcon" />
          </a-date-picker>
        </a-form-item>
        <a-form-item :label="'结束时间'" :colon="false">
          <a-date-picker
            hideDisabledOptions
            @change="checkEndDate"
            format="YYYY-MM-DD HH:mm"
            placeholder="请选择结束时间"
            :disabled-date="disabledEndDate"
            :disabledTime="disabledEndTime"
            :show-time="{ defaultValue: defaultEndDate }"
            v-decorator="[
              'endTime',
              { rules: [{ required: true, message: '请选择结束时间' }, { validator: validateEndTime }] }
            ]"
          >
            <img src="@/assets/icons/icon_rq.png" slot="suffixIcon" />
          </a-date-picker>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item :label="'请选择备课包'" :colon="false">
          <a-button
            class="select-button"
            :class="!form.getFieldValue('lesson') ? 'disabled' : ''"
            @click="lessonPreparePackSelect"
            v-decorator="['lesson', { rules: [{ required: true, message: '请选择备课包' }] }]"
            placeholder="请选择备课包"
          >
            {{ form.getFieldValue('lesson') ? form.getFieldValue('lesson').name : '请选择备课包' }}
            <img src="@/assets/icons/icon_jt.png" alt="" srcset="" />
          </a-button>
        </a-form-item>
      </div>
    </a-form>
    <div class="list-button">
      <a-button type="primary" @click="save">确定</a-button>
    </div>
    <a-modal
      :footer="null"
      title="选择备课包"
      :visible="lessonPreparePackVisible"
      @cancel="lessonPreparePackVisible = false"
    >
      <a-input-search allowClear v-model="name" placeholder="请输入备课包名称" @change="onSearch">
        <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
        <img
          class="clear"
          v-if="name"
          slot="suffix"
          @click=";(name = undefined), onSearch()"
          :src="require('@/assets/icons/icon_gb.png')"
        />
        <a-button class="search-btn" slot="enterButton">
          搜索
        </a-button>
      </a-input-search>
      <a-table :locale="locale" :columns="columns" :data-source="list" :scroll="{ y: 450 }">
        <template slot="name" slot-scope="text, record">
          <a-tooltip class="prepare-name">
            <template slot="title">
              {{ record.name }}
            </template>
            {{ record.name }}
          </a-tooltip>
        </template>
        <template class="operate" slot="operate" slot-scope="text, record">
          <span
            v-if="form.getFieldValue('lesson') && form.getFieldValue('lesson').id === record.id"
            class="button"
            @click="lessonPreparePackRemove()"
            >移除</span
          >
          <span v-else class="button" @click="lessonPreparePackAdd(record)">添加</span>
        </template>
      </a-table>
      <Pagination class="list-pagination" :pagination.sync="pagination" @handleTableChange="handleTableChange" />
    </a-modal>
  </div>
</template>
<script>
import { classMap, lessonSave, lessonDetail, prepareLessonList } from '@/api/lesson'
import moment from 'moment'
import Pagination from '@/components/pagination/index.vue'
import NoData from '@/components/noData/index'

export default {
  components: {
    NoData,
    Pagination
  },
  data() {
    return {
      id: undefined,
      list: [],
      locale: {
        emptyText: <NoData />
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          align: 'center'
        },
        {
          width: 200,
          title: '备课包名称',
          dataIndex: 'name',
          key: 'name',
          align: 'center',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '备课时间',
          dataIndex: 'createdAt',
          key: 'createdAt',
          align: 'center'
        },
        {
          title: '操作',
          key: 'operate',
          align: 'center',
          dataIndex: 'operate',
          scopedSlots: { customRender: 'operate' }
        }
      ],
      pagination: {
        page: 1,
        pageSize: 5,
        total: 0,
        hideOnSinglePage: true
      },
      classOptions: [],
      lessonOption: [],
      prepareLessonId: undefined,
      lessonPreparePackVisible: false,
      form: this.$form.createForm(this),
      lessonPreparePackChecked: undefined
    }
  },
  watch: {
    prepareLessonId: {
      handler() {
        this.form.setFieldsValue({
          lesson: this.list.find(item => {
            return this.prepareLessonId === item.id
          })
        })
      }
    }
  },
  methods: {
    back() {
      this.$router.push({
        name: 'lessonList'
      })
    },
    onSearch() {
      this.pagination.page = 1
      this.getPrepareLessonList()
    },
    handleTableChange() {
      this.getPrepareLessonList()
    },
    disabledStartTime(startTime) {
      let endTime = this.form.getFieldValue('endTime')
      endTime = endTime && typeof endTime === 'string' ? moment(endTime) : endTime
      const fortyFiveMinutesBefore = moment(endTime).subtract(30, 'minutes')
      const threeHoursBefore = moment(endTime).subtract(3, 'hours')
      return {
        disabledHours: () => {
          const disabledArr = []
          const currentHours = moment().hour()
          const endHours = endTime ? moment(endTime).hour() : undefined
          if (moment().isSame(startTime, 'days')) {
            for (let i = 24; i--; i <= 0) {
              if (i < currentHours) {
                disabledArr.push(i)
              }
              if (endTime && moment(endTime).isSame(startTime, 'days') && i > endHours) {
                disabledArr.push(i)
              }
            }
          } else {
            for (let i = 24; i--; i <= 0) {
              if (endTime && moment(endTime).isSame(startTime, 'days') && i > endHours) {
                disabledArr.push(i)
              }
            }
          }
          if (endTime) {
            for (let i = 1; i <= 24; i++) {
              if (
                i > fortyFiveMinutesBefore.hour() ||
                i < threeHoursBefore.hour() ||
                (i <= moment().hour() && moment().date() === endTime.date())
              ) {
                disabledArr.push(i)
              }
            }
          }
          return disabledArr
        },
        disabledMinutes: () => {
          const disabledArr = []
          const currentMinute = moment().minute()
          const endMinute = endTime ? moment(endTime).minute() : undefined
          if (moment().isSame(startTime, 'hours')) {
            for (let i = 60; i--; i <= 0) {
              if (i < currentMinute) {
                disabledArr.push(i)
              }
              if (endTime && moment(endTime).isSame(startTime, 'hours')) {
                disabledArr.push(i)
              }
            }
          }
          if (endTime) {
            if (startTime && startTime.hour() === fortyFiveMinutesBefore.hour()) {
              for (let i = 60; i--; i <= 0) {
                if (i > fortyFiveMinutesBefore.minute()) {
                  disabledArr.push(i)
                }
              }
            } else if (startTime && startTime.hour() > fortyFiveMinutesBefore.hour()) {
              for (let i = 60; i--; i <= 0) {
                disabledArr.push(i)
              }
            } else if (startTime && startTime.hour() === threeHoursBefore.hour()) {
              for (let i = 60; i--; i <= 0) {
                if (i < threeHoursBefore.minute()) {
                  disabledArr.push(i)
                }
              }
            }
          }
          return disabledArr
        }
      }
    },
    disabledStartDate(startValue = new Date().getTime()) {
      const currentTime = moment()
        .hours(0)
        .minutes(0)
        .seconds(0)
        .milliseconds(0)
      const endValue = this.form.getFieldValue('endTime')
      const dayStart = moment(endValue).startOf('day')
      const nextDayStart = moment(endValue)
        .add(1, 'days')
        .startOf('day')
      if (!endValue) {
        return startValue.valueOf() < currentTime
      } else {
        return dayStart.valueOf() >= startValue.valueOf() || startValue.valueOf() >= nextDayStart.valueOf()
      }
    },
    disabledEndTime(endTime = moment()) {
      let startTime = this.form.getFieldValue('startTime')
      startTime = startTime && typeof startTime === 'string' ? moment(startTime) : startTime

      // 获取 30 分钟后的时间
      const fortyFiveMinutesLater = moment(startTime).add(30, 'minutes')
      // 获取 3 小时后的时间
      const newTime = moment(startTime).add(3, 'hours')
      const endOfDay = moment(startTime).endOf('day')
      // 判断是否在同一天
      const isSameDay = startTime.isSame(newTime, 'day')
      const threeHoursLater = newTime.isAfter(endOfDay) ? endOfDay : newTime
      return {
        disabledHours: () => {
          const disabledArr = []
          const currentHours = moment().hour()
          const endHours = startTime ? moment(startTime).hour() : undefined
          if (moment().isSame(endTime, 'days')) {
            for (let i = 24; i--; i <= 0) {
              if (i < currentHours) {
                disabledArr.push(i)
              }
            }
          } else {
            for (let i = 24; i--; i <= 0) {
              if (endTime && moment(startTime).isSame(endTime, 'days') && i < endHours) {
                disabledArr.push(i)
              }
            }
          }
          if (startTime) {
            if (isSameDay) {
              for (let i = 1; i <= 24; i++) {
                if (i < fortyFiveMinutesLater.hour() || i > threeHoursLater.hour()) {
                  disabledArr.push(i)
                }
              }
            } else {
              // 当前选择日期和开始时间是同一天
              if (startTime.isSame(endTime, 'day')) {
                for (let i = 1; i <= 24; i++) {
                  if (i < fortyFiveMinutesLater.hour() || i > threeHoursLater.hour()) {
                    disabledArr.push(i)
                  }
                }
              } else {
                // 当前选择日期和开始时间不是同一天
                for (let i = 1; i <= 24; i++) {
                  if (i > newTime.hour()) {
                    disabledArr.push(i)
                  }
                }
              }
            }
          }
          return disabledArr
        },
        disabledMinutes: () => {
          const disabledArr = []
          const currentMinute = moment().minute()
          const starMinute = startTime ? moment(endTime).minute() : undefined
          if (moment().isSame(endTime, 'hours')) {
            for (let i = 60; i--; i <= 0) {
              if (i < currentMinute) {
                disabledArr.push(i)
              }
              if (startTime && moment(startTime).isSame(endTime, 'hours') && i < starMinute) {
                disabledArr.push(i)
              }
            }
          }
          if (startTime) {
            if (isSameDay) {
              if (endTime && endTime.hour() === fortyFiveMinutesLater.hour()) {
                for (let i = 60; i--; i <= 0) {
                  if (i < fortyFiveMinutesLater.minute()) {
                    disabledArr.push(i)
                  }
                }
              } else if (endTime && endTime.hour() < fortyFiveMinutesLater.hour()) {
                for (let i = 60; i--; i <= 0) {
                  disabledArr.push(i)
                }
              } else if (endTime && endTime.hour() === threeHoursLater.hour()) {
                for (let i = 60; i--; i <= 0) {
                  if (i > threeHoursLater.minute()) {
                    disabledArr.push(i)
                  }
                }
              }
            } else {
              if (startTime.isSame(endTime, 'day')) {
                if (endTime && endTime.hour() === fortyFiveMinutesLater.hour()) {
                  for (let i = 60; i--; i <= 0) {
                    if (i < fortyFiveMinutesLater.minute()) {
                      disabledArr.push(i)
                    }
                  }
                } else if (endTime && endTime.hour() < fortyFiveMinutesLater.hour()) {
                  for (let i = 60; i--; i <= 0) {
                    disabledArr.push(i)
                  }
                } else if (endTime && endTime.hour() === threeHoursLater.hour()) {
                  for (let i = 60; i--; i <= 0) {
                    if (i > threeHoursLater.minute()) {
                      disabledArr.push(i)
                    }
                  }
                }
              } else {
                if (endTime && endTime.hour() === newTime.hour()) {
                  for (let i = 60; i--; i <= 0) {
                    if (i > newTime.minute()) {
                      disabledArr.push(i)
                    }
                  }
                }
              }
            }
          }
          return disabledArr
        }
      }
    },
    disabledEndDate(endValue = new Date().getTime()) {
      const currentTime = moment()
        .hours(0)
        .minutes(0)
        .seconds(0)
        .milliseconds(0)
      const startValue = this.form.getFieldValue('startTime')
      const dayStart = moment(startValue).startOf('day')
      const nextDayStart = moment(startValue)
        .add(3, 'hours')
        .add(1, 'days')
        .startOf('day')
      if (!startValue) {
        return endValue.valueOf() < currentTime
      } else {
        return dayStart.valueOf() >= endValue.valueOf() || endValue.valueOf() > nextDayStart.valueOf()
      }
    },
    lessonPreparePackSelect() {
      this.lessonPreparePackVisible = true
    },
    // 添加备课包
    lessonPreparePackAdd(obj) {
      this.$message.success('添加成功！')
      this.lessonPreparePackVisible = false
      this.prepareLessonId = obj.id
    },
    // 移除备课包
    lessonPreparePackRemove(id) {
      this.prepareLessonId = undefined
      this.form.setFieldsValue({
        lesson: undefined
      })
      this.$message.success('移除成功！')
      this.lessonPreparePackVisible = false
    },
    save(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        console.log('err ----->', err)
        console.log('values.endTime ----->', values.endTime)
        if (!err) {
          const data = Object.assign(values, {
            id: this.id,
            classId: Number(values.classId),
            prepareLessonId: Number(values.lesson.id),
            endTime: moment(values.endTime)
              .startOf('minute')
              .format('YYYY-MM-DD HH:mm:ss'),
            startTime: moment(values.startTime)
              .startOf('minute')
              .format('YYYY-MM-DD HH:mm:ss')
          })
          delete data.lesson
          console.log('Received values of form: ', data)
          lessonSave(data).then(res => {
            if (res.code == 200) {
              const tip = this.id ? '编辑' : '创建'
              this.$message.success(tip + '成功！')
              this.back()
            }
          })
        }
      })
    },
    getLessonDetail() {
      lessonDetail({
        id: this.id
      }).then(res => {
        if (res.code != 200) return
        this.form.setFieldsValue({
          name: res.data.name,
          classId: res.data.classId,
          endTime: res.data.endTime,
          startTime: res.data.startTime
        })
        this.disabledEndDate(moment(res.data.endTime))
        this.disabledStartDate(moment(res.data.startTime))
        this.prepareLessonId = res.data.prepareLessonId
      })
    },
    getPrepareLessonList() {
      prepareLessonList({
        name: this.name,
        pageSize: this.pagination.pageSize,
        page: this.pagination.page
      }).then(res => {
        if (res.code != 200) return
        this.list = res.data.list
        this.pagination.total = res.data.total
        if (this.id) {
          this.getLessonDetail()
        }
      })
    },
    getClassList() {
      classMap().then(res => {
        if (res.code != 200) return
        this.classOptions = res.data.list
      })
    },
    validateEndTime(rule, value, callback) {
      const form = this.form
      const startTime = form.getFieldValue('startTime')
      const thirtyMinutesLater = moment(startTime).add(30, 'minutes')
      // 获取 3 小时后的时间
      const threeHoursLater = moment(startTime).add(3, 'hours')
      if (value && (value.valueOf() < thirtyMinutesLater.valueOf() || value.valueOf() > threeHoursLater.valueOf())) {
        callback('时间间隔需要在30分钟至3小时之内')
      }
      callback()
    }
  },
  mounted() {
    this.getClassList()
    this.getPrepareLessonList()
    this.id = this.$route.query.id
  }
}
</script>

<style lang="less" scoped>
.container {
  padding: 18px 21px;
}
.header {
  margin-bottom: 22px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ededed;
  .title {
    font-size: 16px;
    font-weight: 800;
    color: #000000;
  }
}
.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;
  img {
    height: 10px;
    margin-right: 9px;
  }
}
.button {
  cursor: pointer;
}
.ant-form {
  position: relative;
  height: calc(100% - 100px);
  .list {
    display: flex;
    margin-bottom: 12px;
    .ant-form-item-label {
      font-size: 14px;
      color: #000;
      line-height: 20px;
    }
    .ant-form-item {
      width: calc((100% - 70px) / 2);
      margin-bottom: 0;
      &:first-child {
        margin-right: 70px;
      }
    }
    /deep/.select-button.ant-btn.disabled {
      color: #a2a2a2 !important;
      background: none;
    }
    /deep/.ant-input,
    /deep/.select-button.ant-btn,
    /deep/.ant-input-affix-wrapper {
      width: 100%;
      height: 35px;
      color: #000000 !important;
      margin-right: 11px;
    }
    /deep/.ant-select-selection__rendered {
      .ant-select-selection-selected-value {
        color: #000;
      }
    }
    .ant-calendar-picker div {
      position: relative;
      .ant-calendar-picker-input .ant-input {
        width: 100%;
        height: 35px;
        margin-right: 0;
        border-radius: 4px;
        background: #ffffff;
        border: 1px solid #d8dce0;
      }
    }
    .select-button,
    .ant-calendar-picker {
      width: 100%;
      height: 35px;
      color: #000000;
      line-height: 35px;
    }
    .select-button {
      padding: 0 20px;
      text-align: left;
      color: #a2a2a2;
      position: relative;
      img {
        top: 14px;
        width: 11px;
        right: 20px;
        position: absolute;
      }
    }
  }
}
.list-button {
  display: flex;
  justify-content: center;
}
/deep/.ant-modal {
  width: 737px !important;
  .ant-modal-title {
    font-size: 16px;
    font-weight: 550;
  }
  .total {
    color: #687f9c;
    margin: 12px 0;
  }
  .ant-input-group-wrapper {
    width: 330px;
    height: 35px;
    margin-bottom: 22px;
    .ant-input-prefix {
      // right: auto;
      left: 16px;
      img {
        width: 16px;
      }
    }
    .ant-input-suffix {
      right: 0;
      .anticon.anticon-close-circle.ant-input-clear-icon {
        display: none;
      }
      .clear {
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
    }
    .ant-input-search {
      height: 35px;
      .ant-input {
        height: 35px;
        color: #000;
        padding-left: 46px;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        border-color: #d8dce0;
        box-shadow: none;
      }
    }
    .ant-input-group-addon .search-btn {
      border-left: 0;
      height: 35px;
      border-color: #d8dce0;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
      span {
        display: flex;
        font-size: 14px;
        color: #333333;
        position: relative;
        align-items: center;
        &::before {
          left: -8px;
          content: '';
          width: 1px;
          height: 15px;
          background: #e9e9e9;
          position: absolute;
        }
      }
    }
    // border: 1px solid #D8DCE0;
  }
  .ant-modal-body {
    position: relative;
    .ant-table-wrapper {
      margin-bottom: 60px;
      .prepare-name {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        white-space: nowrap;
        display: inline-block;
      }
      .button {
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        color: #5b7499;
        line-height: 20px;
        margin-right: 10px;
      }
    }
    .list-pagination {
      width: calc(100% - 48px);
      bottom: 80px;
      position: absolute;
      .pagination {
        padding: 25px 0;
      }
    }
  }
}
.ant-table,
.ant-btn {
  color: #000;
}
</style>
